import React, { useMemo, useState, useEffect } from "react";
import { Table } from "../../Components/Table/Table";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useNavigate } from "react-router-dom";
import { getMyProfile, getAllEmployees } from "../../api/register";
import { getUser } from "../../utils/Storage";

const Profile = () => {
  const navigate = useNavigate();
  const [pageno, setPageno] = useState(1);
  const [employee, setEmployee] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const user = getUser(); // from login
      let empArr = [];

      if (user?.role === "admin" || user?.role === "superadmin") {
        const res = await getAllEmployees();
        empArr = Array.isArray(res?.data?.employees) ? res.data.employees : [];
      } else if (user?.role === "employee") {
        const res = await getMyProfile();
        const emp = res?.data?.employee;
        empArr = emp ? [emp] : [];
      }

      setEmployee(empArr);
    } catch (error) {
      console.error("Profile fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const data = useMemo(() => {
    return employee.map((emp, index) => ({
      employeeId: emp?.employeeId || `EMP-${index + 1}`,
      username: `${emp?.firstName || ""} ${emp?.lastName || ""}`,
      personalmailid: emp?.personalmailid || emp?.email || "-",
      mobilenumber: emp?.mobilenumber || "-",
      status: emp?.role === "employee" ? "Active" : "Blocked",
      userId: emp?.employeeId,
    }));
  }, [employee]);

  const columns = useMemo(
    () => [
      { Header: "S.No", Cell: ({ row }) => row.index + 1 },
      { Header: "Employee ID", accessor: "employeeId" },
      { Header: "Name", accessor: "username" },
      { Header: "Email", accessor: "personalmailid" },
      { Header: "Mobile Number", accessor: "mobilenumber" },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (
          <span
            style={{
              padding: "4px 10px",
              borderRadius: "6px",
              backgroundColor: value === "Active" ? "#d4edda" : "#f8d7da",
              color: value === "Active" ? "#155724" : "#721c24",
            }}
          >
            {value}
          </span>
        ),
      },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div style={{ cursor: "pointer" }}>
            <RemoveRedEyeIcon
              onClick={() => navigate(`/register-view/${row.original.userId}`)}
            />
          </div>
        ),
      },
    ],
    [navigate]
  );

  return (
    <div className="container-admin">
      <h2 className="mb-3">Employee Profile</h2>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <Table columns={columns} data={data} pageno={pageno} setPageno={setPageno} show={true} />
      )}
    </div>
  );
};

export default Profile;